export function formatCurrency(rawCents: number | string) {
  const cents = Number(rawCents);
  const floatValue = cents / 100;
  const textValue = floatValue
      .toFixed(2)
      .replace('.', ',');
  
  return `R$ ${textValue}`;
}
